export enum StatesInOffersSource {
    Web = 0,
    Portal = 1
}